module.exports = __webpack_public_path__ + "img/12_People Manager.e3e072b1.svg";